import ScheduleStatusMessage from './ScheduleStatusMessage'

export default ScheduleStatusMessage
